import React from "react";
import without from "lodash/without";
import { gettext } from "../../adapter";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const FilterBoxInput = ({ input }) => {
  const { search } = useLocation();
  const history = useHistory();
  var title = input.title;

  var filterIds = [];
  let query = queryString.parse(search);
  if (query.filters) {
    filterIds = query.filters.split("-");
  }

  const onChange = (e) => {
    var id = input.id;
    var reversed = input.reversed;

    var filterIds = [];
    let query = queryString.parse(search);
    if (query.filters) {
      filterIds = query.filters.split("-");
    }

    const checked = filterIds.includes(id.toString());
    if ((!checked && reversed) || (!checked && !reversed)) {
      // Checked
      filterIds.push(id);
    } else {
      filterIds = without(filterIds, id.toString());
    }

    if (filterIds.length > 0) {
      query.filters = filterIds.join("-");
    } else {
      delete query.filters;
    }
    history.push("?" + queryString.stringify(query));
  };

  title = title === "undefined" ? "Geen" : title;

  if (
    input.filterGroup === "status" ||
    input.filterGroup === "soilMoistureStatus" ||
    input.filterGroup === "period"
  ) {
    switch (title) {
      case "belowRefillPoint":
        title = gettext("Below refill point");
        break;
      case "belowWarningPoint":
        title = gettext("Below warning point");
        break;
      case "aboveFieldCapacity":
        title = gettext("Above field capacity");
        break;
      case "normal":
        title = gettext("Normal moisture status");
        break;
      case "noData":
        title = gettext("No recent measurements");
        break;
      case "now":
        title = gettext("Current");
        break;
      case "last_year":
        title = gettext("Last year");
        break;
      case "past":
        title = gettext("In the past");
        break;
      default:
        break;
    }
  }

  const included = filterIds.includes(input.id.toString());
  const checked = (included && !input.reversed) || (!included && input.reversed);

  return (
    <li>
      <label className="checkbox-label" htmlFor={input.id}>
        <input
          type="checkbox"
          onChange={onChange}
          name={input.title}
          id={input.id}
          value={input.id}
          defaultChecked={checked}
        />
        <span className="checkbox"></span>
        {capitalizeFirstLetter(title)} ({input.count})
      </label>
    </li>
  );
};

export default FilterBoxInput;
